import axios from 'axios';
import { config } from './apiConfig';

const get = async (parameters) => {
    let result = [];
    let AccessToken = localStorage.getItem('AccessToken');
    if (AccessToken) {
        let response = await axios.get(`${config.url}/api/mvc/${parameters.ctrl}/${parameters.method}/${parameters.query}`,
            {
                headers: {
                    "Authorization": `Bearer ${AccessToken}` }
            }).catch((error) => {
                if (error.response?.status === 401) {
                    //  window.location.replace(window.location.origin);
                    result.status = "401";
                    result.data = "Unauthorized";
                    return result;
                }
            });
        result.status = response?.status;
        result.data =  response?.data;
        return result;
    } else {
         window.location.href = 'https://iranhotelonline.com';
    }
    // let tokenStr = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxNTQ4OTciLCJGY21JZCI6IjAiLCJSZWdpc3RlclR5cGUiOiIzIiwicm9sZSI6IkFnZW5jaWVzIiwibmJmIjoxNzIyNTExMjM0LCJleHAiOjE3MjMxMTYwMzQsImlhdCI6MTcyMjUxMTIzNH0.nxft9gPc7EDxK-HgsqVd35fyEUwrraYESwMFcsn0Aog`;

}

export default get;